export default "__VITE_ASSET__BeySEFeg__"